var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosteModelCreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7334 25.0002L16.7171 23.1934V18.5566L12.7334 20.3635V25.0002Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7334 15.8337L16.7171 17.6623V13.0256L12.7334 11.2188V15.8337Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4503 16.3359L8.59717 18.0992L12.4503 19.8843L16.3033 18.0992L12.4503 16.3359Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18359 23.1934L12.1673 25.0002V20.3635L8.18359 18.5566V23.1934Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5499 16.3359L17.6968 18.0992L21.5499 19.8843L25.403 18.0992L21.5499 16.3359Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2832 23.1934L21.2669 25.0002V20.3635L17.2832 18.5566V23.1934Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 9L13.1467 10.7633L16.9998 12.5266L20.8529 10.7633L16.9998 9Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8328 20.3635V25.0002L25.8165 23.1934V18.5566L21.8328 20.3635Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2832 17.6623L21.2669 15.8337V11.2188L17.2832 13.0256V17.6623Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosteModelCreation);
export default __webpack_public_path__ + "static/media/CosteModelCreation.afed1746f9bb45930bc2a60b7d292b84.svg";
export { ForwardRef as ReactComponent };